import { Injectable } from '@angular/core';
import { ServiceLibrary } from '@common_libraries/helpers/ServiceLibrary';
import { Observable } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';

@Injectable({providedIn: 'root'})
export class LoginService {

  public constructor(private servLib: ServiceLibrary ) { }

  public Login(username: string, password: string): Observable<{ status: number, body: string}> {
    return this.servLib.Login(username, password);
  }
}
